// extracted by mini-css-extract-plugin
export default {"paragraph":"MatrixQuote-module__paragraph--L9Z0n"};